var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5 9.51665C29.85 8.86665 28.8 8.86665 28.15 9.51665L20 17.65L11.85 9.49998C11.2 8.84998 10.15 8.84998 9.50001 9.49998C8.85001 10.15 8.85001 11.2 9.50001 11.85L17.65 20L9.50001 28.15C8.85001 28.8 8.85001 29.85 9.50001 30.5C10.15 31.15 11.2 31.15 11.85 30.5L20 22.35L28.15 30.5C28.8 31.15 29.85 31.15 30.5 30.5C31.15 29.85 31.15 28.8 30.5 28.15L22.35 20L30.5 11.85C31.1333 11.2166 31.1333 10.15 30.5 9.51665Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCloseIcon);
export default __webpack_public_path__ + "static/media/CloseIcon.ec8663d635e92f82077a9ef18a831b92.svg";
export { ForwardRef as ReactComponent };